/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react'
import {arrayToCombo} from '../../Helpers'

class GaraPartecipatoComboFilter extends Component {
    constructor(props) {
        super(props);
        let fields = {statoPartecipato: props.statoPartecipato}
        this.state = {
            fields: fields,
            dropdownLoading: false,
            dropdownList: [],
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.comboScelte = this.comboScelte.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if (nextProps.statoPartecipato !== this.state.fields.statoPartecipato)
        {
            let fields = this.state.fields;
            fields.statoPartecipato = nextProps.statoPartecipato;
            this.setState({fields},
                ()=>{
                    if ( this.state.fields.statoPartecipato !== undefined){
                        this.props.onChange(
                            this.state.fields.statoPartecipato,
                            this.getDDText(this.state.fields.statoPartecipato, this.state.dropdownList)
                        );
                    }
                });
        }
    }

    componentDidMount(){
        this.comboScelte();
    }

    getDDText(value, options){
        let selectedItem = options.find((it) => {
            return it.value === value;
        })
        return selectedItem ? selectedItem.text : '0';
    }

    comboScelte(){
        let items = [
            {statoPartecipato: '0', nome: 'Tutte le gare (partecipate e non)'},
            {statoPartecipato: '1', nome: 'Gare a cui si è partecipato'},
            {statoPartecipato: '-1', nome: 'Gare a cui non si è partecipato'}
        ];
        this.setState(
            {
                dropdownLoading: false,
                error: null,
                dropdownList: arrayToCombo(items, "statoPartecipato", "nome", "statoPartecipato", false)
            },
            ()=>{
            if ( this.state.fields.statoPartecipato !== undefined){
                this.props.onChange(
                    this.state.fields.statoPartecipato,
                    this.getDDText(this.state.fields.statoPartecipato, this.state.dropdownList)
                );
            }
        })
    }

    onInputChange(a1, b1) {

        let name = b1.name;
        let value = b1.value;

        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields }, () => {
                this.props.onChange(this.state.fields.statoPartecipato, this.getDDText(value, b1.options));
            });

        }
    }

    render() {
        return (
            <div className="ui form">
                    <Form.Field className="fields">
                        <Form.Dropdown width={16} style={{width:"100%"}} name='statoPartecipato' disabled={this.props.abilitato === false} loading={this.state.dropdownLoading} search selection options={this.state.dropdownList} value={this.state.fields.statoPartecipato} onChange={this.onInputChange}/>
                    </Form.Field>
            </div>)
    }
}

GaraPartecipatoComboFilter.PropTypes = {
    statoPartecipato: PropTypes.string.isRequired, // -1: tutte, 1: Partecipato, 0: Non partecipato
    abilitato: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

GaraPartecipatoComboFilter.defaultProps = {
    statoPartecipato: '0',
    abilitato: false
};
export default GaraPartecipatoComboFilter;



/** WEBPACK FOOTER **
 ** ./src/components/gare/GaraPartecipatoComboFilter.js
 **/